@import (reference) '../../../../../constants/spacing.module.less';

.wrapper {
  width: 320px;
  padding: @space-16 @space-0;
}
